import React from 'react';
import { Pill } from '../../ui';

interface KeywordChipProps {
  keyword: string;
  /** `true` when the user has toggled the chip off — strikethrough state. */
  removed?: boolean;
  /** `true` for chips the user added manually (vs AI-suggested). */
  isAdded?: boolean;
  /** Omit to render a read-only chip (used by the success card). */
  onToggle?: () => void;
}

/** Style override for the toggled-off state: muted, dashed, struck through. */
const removedStyle: React.CSSProperties = {
  background: 'transparent',
  border: '1px dashed var(--border-2)',
  color: 'var(--fg-3)',
  textDecoration: 'line-through',
};

const KeywordChip: React.FC<KeywordChipProps> = ({ keyword, removed, isAdded, onToggle }) => {
  const interactive = typeof onToggle === 'function';
  const tooltip = isAdded ? 'Added manually' : interactive ? 'Suggested by AI' : undefined;
  return (
    <Pill
      tone="accent"
      size="sm"
      active={interactive && !removed}
      onClick={interactive ? onToggle : undefined}
      title={tooltip}
      style={removed ? removedStyle : undefined}
    >
      {isAdded && <span style={{ fontSize: 10, fontWeight: 700 }}>+</span>}
      {keyword}
      {interactive && (
        <span style={{ fontSize: 11, opacity: 0.7 }}>{removed ? '+' : '×'}</span>
      )}
    </Pill>
  );
};

export default KeywordChip;
